/* Wellstraps – Fast Boot for Rise
   Делает интерактив мгновенным, пока тема/аппы догружаются. */

(function () {
  // 0) Мини-помощники
  var d = document, w = window;
  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn, { passive: true }); };
  var $all = function (sel, root) { return (root || d).querySelectorAll(sel); };
  var $ = function (sel, root) { return (root || d).querySelector(sel); };

  // 1) Сразу помогаем браузеру с соединениями и критикой (без правки <head>)
  try {
    var head = d.head || d.getElementsByTagName('head')[0];
    ['https://cdn.shopify.com', 'https://fonts.shopifycdn.com'].forEach(function (url) {
      var l = d.createElement('link'); l.rel = 'preconnect'; l.href = url; l.crossOrigin = 'anonymous'; head.appendChild(l);
    });
  } catch (e) {}

  // 2) Снимаем искусственные блокировки кликов/disabled
  function unlockInteractive() {
    var sel = [
      '[data-wait-for-js]',
      'button[disabled][type="submit"]',
      'a[aria-disabled="true"]',
      '.button[disabled]',
      '[data-fast-link]',
      'button[disabled].product-form__submit',
      '.shopify-payment-button__button[disabled]'
    ].join(',');
    $all(sel).forEach(function (el) {
      el.removeAttribute('disabled');
      el.setAttribute('aria-disabled','false');
      el.style.pointerEvents = 'auto';
      el.style.opacity = '';
    });
  }
  unlockInteractive();

  // 3) Мгновенный Add to Cart (раньше, чем прогрузится тема)
  function fastAddToCart(form) {
    try {
      var fd = new FormData(form);
      // Если не выбран вариант - попробуем взять первый доступный
      if (!fd.get('id')) {
        var variant = d.querySelector('[name="id"][value]') || d.querySelector('select[name="id"] option[selected]');
        if (variant && variant.value) { fd.append('id', variant.value); }
      }
      if (!fd.get('quantity')) fd.append('quantity','1');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd,
        credentials: 'same-origin'
      }).then(function (res) { return res.json(); })
      .then(function () {
        toast('Added to cart');
        d.dispatchEvent(new CustomEvent('fast:cart-updated'));
      }).catch(function () {
        try { form.submit(); } catch(_){}
      });
    } catch (e) {
      try { form.submit(); } catch(_){}
    }
  }

  function wireProductForms(root) {
    $all('form[action*="/cart/add"]', root).forEach(function (form) {
      if (form.__fastBound) return;
      form.__fastBound = true;

      $all('button[type="submit"], [type="submit"]', form).forEach(function(btn){
        btn.removeAttribute('disabled'); btn.style.pointerEvents='auto';
      });

      form.addEventListener('submit', function (e) {
        var themeReady = w.Shopify && (w.Shopify.theme || w.Shopify.designMode || w.Shopify.analytics);
        if (!themeReady) {
          e.preventDefault();
          fastAddToCart(form);
        }
      }, { capture: true });
    });
  }
  wireProductForms();

  // 4) Быстрые кнопки на карточках (если есть data-variant-id)
  function wireCardQuickATC(root) {
    $all('[data-variant-id]:not([data-fast])', root).forEach(function(btn){
      btn.dataset.fast = '1';
      btn.addEventListener('click', function(e){
        var id = btn.getAttribute('data-variant-id');
        if(!id) return;
        e.preventDefault();
        var f = new FormData(); f.append('id', id); f.append('quantity', '1');
        fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body:f })
          .then(()=> toast('Added to cart'))
          .catch(()=> location.href = '/cart/add?id='+encodeURIComponent(id)+'&quantity=1');
      }, { passive: false });
    });
  }
  wireCardQuickATC();

  // 5) Не даём поп-апам блокировать первый клик (2.5s)
  (function shieldOverlays(){
    var css = [
      'html.fast-boot *[role="dialog"]',
      'html.fast-boot .popup',
      'html.fast-boot .modal',
      'html.fast-boot .klaviyo-form',
      'html.fast-boot .privy',
      'html.fast-boot .newsletter-popup',
      'html.fast-boot .pushowl-onboarding-modal'
    ].join(',') + ' { display: none !important; }';
    var style = d.createElement('style'); style.textContent = css; (d.head||d.documentElement).appendChild(style);
    d.documentElement.classList.add('fast-boot');
    setTimeout(function(){
      d.documentElement.classList.remove('fast-boot');
      try { style.remove(); } catch(_){}
    }, 2500);
  })();

  // 6) Наблюдаем за DOM
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function(node){
          if (!node.querySelector) return;
          wireProductForms(node);
          wireCardQuickATC(node);
          unlockInteractive();
        });
      }
    });
  });
  mo.observe(d.documentElement, { childList: true, subtree: true });

  // 7) Простой тост
  function toast(text) {
    try {
      var el = $('#fast-toast');
      if (!el) {
        el = d.createElement('div');
        el.id = 'fast-toast';
        el.style.position='fixed'; el.style.zIndex='2147483647';
        el.style.left='50%'; el.style.top='20px'; el.style.transform='translateX(-50%)';
        el.style.padding='10px 14px'; el.style.borderRadius='10px';
        el.style.background='rgba(0,0,0,.8)'; el.style.color='#fff'; el.style.fontSize='14px';
        el.style.pointerEvents='none'; el.style.transition='opacity .25s ease';
        el.style.opacity='0';
        d.body.appendChild(el);
      }
      el.textContent = text || 'Done';
      el.style.opacity='1';
      clearTimeout(el.__t);
      el.__t = setTimeout(function(){ el.style.opacity='0'; }, 1400);
    } catch(e){}
  }

  // 8) Дублируем после DOMContentLoaded
  d.addEventListener('DOMContentLoaded', function(){
    unlockInteractive();
    wireProductForms();
    wireCardQuickATC();
  });
})();
